// extracted by mini-css-extract-plugin
module.exports = {"chart":"Dashboard_chart__1rHuw","spinner":"Dashboard_spinner__1HhwA","month":"Dashboard_month__xYG5U"};